/* src/app/home-new/mobile-buttons-bar/mobile-buttons-bar.component.scss */
ion-button {
  flex-grow: 1;
  --background: #f6f6f6;
  --background-hover: #f6f6f6;
  --background-activated: #f6f6f6;
  --background-focused: #f6f6f6;
  padding: 12px 16px;
  --border-radius: 15px;
  --border-width: 0px;
}
ion-button ion-label {
  font-weight: 600;
  font-size: 16px;
  color: black;
}
ion-button ion-icon {
  fill: black;
  font-size: 20px;
}
ion-button ion-icon:first-child {
  margin-right: 10px;
}
ion-button ion-icon:last-child {
  margin-left: 10px;
}
.disabled {
  opacity: 40%;
  pointer-events: none;
}
.disabled * {
  pointer-events: none;
}
/*# sourceMappingURL=mobile-buttons-bar.component-ISRFYXXC.css.map */
